export interface ICountry {
  code: string;
  code3: string;
  name: string;
  number: string;
  nationality: string;
  flag: string;
}

export const COUNTRIES: ICountry[] = [
  { code: 'US', code3: 'USA', name: 'USA', number: '840', nationality: 'American', flag: '🇺🇸' },
  { code: 'CA', code3: 'CAN', name: 'Canada', number: '124', nationality: 'Canadian', flag: '🇨🇦' },
  {
    code: 'AF',
    code3: 'AFG',
    name: 'Afghanistan',
    number: '004',
    nationality: 'Afghan',
    flag: '🇦🇫'
  },
  { code: 'AL', code3: 'ALB', name: 'Albania', number: '008', nationality: 'Albanian', flag: '🇦🇱' },
  { code: 'DZ', code3: 'DZA', name: 'Algeria', number: '012', nationality: 'Algerian', flag: '🇩🇿' },
  {
    code: 'AS',
    code3: 'ASM',
    name: 'American Samoa',
    number: '016',
    nationality: 'American Samoan',
    flag: '🇦🇸'
  },
  { code: 'AD', code3: 'AND', name: 'Andorra', number: '020', nationality: 'Andorran', flag: '🇦🇩' },
  { code: 'AO', code3: 'AGO', name: 'Angola', number: '024', nationality: 'Angolan', flag: '🇦🇴' },
  {
    code: 'AI',
    code3: 'AIA',
    name: 'Anguilla',
    number: '660',
    nationality: 'Anguillan',
    flag: '🇦🇮'
  },
  {
    code: 'AQ',
    code3: 'ATA',
    name: 'Antarctica',
    number: '010',
    nationality: 'Antarctic',
    flag: '🇦🇶'
  },
  {
    code: 'AG',
    code3: 'ATG',
    name: 'Antigua and Barbuda',
    number: '028',
    nationality: 'Antiguan and Barbudan',
    flag: '🇦🇬'
  },
  {
    code: 'AR',
    code3: 'ARG',
    name: 'Argentina',
    number: '032',
    nationality: 'Argentine',
    flag: '🇦🇷'
  },
  { code: 'AM', code3: 'ARM', name: 'Armenia', number: '051', nationality: 'Armenian', flag: '🇦🇲' },
  { code: 'AW', code3: 'ABW', name: 'Aruba', number: '533', nationality: 'Aruban', flag: '🇦🇼' },
  {
    code: 'AU',
    code3: 'AUS',
    name: 'Australia',
    number: '036',
    nationality: 'Australian',
    flag: '🇦🇺'
  },
  { code: 'AT', code3: 'AUT', name: 'Austria', number: '040', nationality: 'Austrian', flag: '🇦🇹' },
  {
    code: 'AZ',
    code3: 'AZE',
    name: 'Azerbaijan',
    number: '031',
    nationality: 'Azerbaijani',
    flag: '🇦🇿'
  },
  { code: 'BS', code3: 'BHS', name: 'Bahamas', number: '044', nationality: 'Bahamian', flag: '🇧🇸' },
  { code: 'BH', code3: 'BHR', name: 'Bahrain', number: '048', nationality: 'Bahraini', flag: '🇧🇭' },
  {
    code: 'BD',
    code3: 'BGD',
    name: 'Bangladesh',
    number: '050',
    nationality: 'Bangladeshi',
    flag: '🇧🇩'
  },
  {
    code: 'BB',
    code3: 'BRB',
    name: 'Barbados',
    number: '052',
    nationality: 'Barbadian',
    flag: '🇧🇧'
  },
  {
    code: 'BY',
    code3: 'BLR',
    name: 'Belarus',
    number: '112',
    nationality: 'Belarusian',
    flag: '🇧🇾'
  },
  { code: 'BE', code3: 'BEL', name: 'Belgium', number: '056', nationality: 'Belgian', flag: '🇧🇪' },
  { code: 'BZ', code3: 'BLZ', name: 'Belize', number: '084', nationality: 'Belizean', flag: '🇧🇿' },
  { code: 'BJ', code3: 'BEN', name: 'Benin', number: '204', nationality: 'Beninese', flag: '🇧🇯' },
  {
    code: 'BM',
    code3: 'BMU',
    name: 'Bermuda',
    number: '060',
    nationality: 'Bermudian',
    flag: '🇧🇲'
  },
  { code: 'BT', code3: 'BTN', name: 'Bhutan', number: '064', nationality: 'Bhutanese', flag: '🇧🇹' },
  { code: 'BO', code3: 'BOL', name: 'Bolivia', number: '068', nationality: 'Bolivian', flag: '🇧🇴' },
  {
    code: 'BQ',
    code3: 'BES',
    name: 'Bonaire, Sint Eustatius and Saba',
    number: '535',
    nationality: 'Bonairean',
    flag: '🇧🇶'
  },
  {
    code: 'BA',
    code3: 'BIH',
    name: 'Bosnia and Herzegovina',
    number: '070',
    nationality: 'Bosnian',
    flag: '🇧🇦'
  },
  {
    code: 'BW',
    code3: 'BWA',
    name: 'Botswana',
    number: '072',
    nationality: 'Botswanan',
    flag: '🇧🇼'
  },
  {
    code: 'BV',
    code3: 'BVT',
    name: 'Bouvet Island',
    number: '074',
    nationality: 'Bouvet Islander',
    flag: '🇧🇻'
  },
  { code: 'BR', code3: 'BRA', name: 'Brazil', number: '076', nationality: 'Brazilian', flag: '🇧🇷' },
  {
    code: 'IO',
    code3: 'IOT',
    name: 'British Indian Ocean Territory',
    number: '086',
    nationality: 'British Indian Ocean Territory',
    flag: '🇮🇴'
  },
  {
    code: 'BN',
    code3: 'BRN',
    name: 'Brunei Darussalam',
    number: '096',
    nationality: 'Bruneian',
    flag: '🇧🇳'
  },
  {
    code: 'BG',
    code3: 'BGR',
    name: 'Bulgaria',
    number: '100',
    nationality: 'Bulgarian',
    flag: '🇧🇬'
  },
  {
    code: 'BF',
    code3: 'BFA',
    name: 'Burkina Faso',
    number: '854',
    nationality: 'Burkinabe',
    flag: '🇧🇫'
  },
  {
    code: 'BI',
    code3: 'BDI',
    name: 'Burundi',
    number: '108',
    nationality: 'Burundian',
    flag: '🇧🇮'
  },
  {
    code: 'CV',
    code3: 'CPV',
    name: 'Cabo Verde',
    number: '132',
    nationality: 'Cape Verdean',
    flag: '🇨🇻'
  },
  {
    code: 'KH',
    code3: 'KHM',
    name: 'Cambodia',
    number: '116',
    nationality: 'Cambodian',
    flag: '🇰🇭'
  },
  {
    code: 'CM',
    code3: 'CMR',
    name: 'Cameroon',
    number: '120',
    nationality: 'Cameroonian',
    flag: '🇨🇲'
  },
  {
    code: 'KY',
    code3: 'CYM',
    name: 'Cayman Islands',
    number: '136',
    nationality: 'Caymanian',
    flag: '🇰🇾'
  },
  {
    code: 'CF',
    code3: 'CAF',
    name: 'Central African Republic',
    number: '140',
    nationality: 'Central African',
    flag: '🇨🇫'
  },
  { code: 'TD', code3: 'TCD', name: 'Chad', number: '148', nationality: 'Chadian', flag: '🇹🇩' },
  { code: 'CL', code3: 'CHL', name: 'Chile', number: '152', nationality: 'Chilean', flag: '🇨🇱' },
  { code: 'CN', code3: 'CHN', name: 'China', number: '156', nationality: 'Chinese', flag: '🇨🇳' },
  {
    code: 'CX',
    code3: 'CXR',
    name: 'Christmas Island',
    number: '162',
    nationality: 'Christmas Islander',
    flag: '🇨🇽'
  },
  {
    code: 'CC',
    code3: 'CCK',
    name: 'Cocos (Keeling) Islands ',
    number: '166',
    nationality: 'Cocos Islander',
    flag: '🇨🇨'
  },
  {
    code: 'CO',
    code3: 'COL',
    name: 'Colombia',
    number: '170',
    nationality: 'Colombian',
    flag: '🇨🇴'
  },
  { code: 'KM', code3: 'COM', name: 'Comoros ', number: '174', nationality: 'Comoran', flag: '🇰🇲' },
  {
    code: 'CD',
    code3: 'COD',
    name: 'Congo (the Democratic Republic of the)',
    number: '180',
    nationality: 'Congolese',
    flag: '🇨🇩'
  },
  { code: 'CG', code3: 'COG', name: 'Congo ', number: '178', nationality: 'Congolese', flag: '🇨🇬' },
  {
    code: 'CK',
    code3: 'COK',
    name: 'Cook Islands ',
    number: '184',
    nationality: 'Cook Islander',
    flag: '🇨🇰'
  },
  {
    code: 'CR',
    code3: 'CRI',
    name: 'Costa Rica',
    number: '188',
    nationality: 'Costa Rican',
    flag: '🇨🇷'
  },
  { code: 'HR', code3: 'HRV', name: 'Croatia', number: '191', nationality: 'Croatian', flag: '🇭🇷' },
  { code: 'CU', code3: 'CUB', name: 'Cuba', number: '192', nationality: 'Cuban', flag: '🇨🇺' },
  {
    code: 'CW',
    code3: 'CUW',
    name: 'Curaçao',
    number: '531',
    nationality: 'Curaçaoan',
    flag: '🇨🇼'
  },
  { code: 'CY', code3: 'CYP', name: 'Cyprus', number: '196', nationality: 'Cypriot', flag: '🇨🇾' },
  { code: 'CZ', code3: 'CZE', name: 'Czechia', number: '203', nationality: 'Czech', flag: '🇨🇿' },
  {
    code: 'CI',
    code3: 'CIV',
    name: 'Côte dIvoire',
    number: '384',
    nationality: 'Ivorian',
    flag: '🇨🇮'
  },
  { code: 'DK', code3: 'DNK', name: 'Denmark', number: '208', nationality: 'Danish', flag: '🇩🇰' },
  {
    code: 'DJ',
    code3: 'DJI',
    name: 'Djibouti',
    number: '262',
    nationality: 'Djiboutian',
    flag: '🇩🇯'
  },
  {
    code: 'DM',
    code3: 'DMA',
    name: 'Dominica',
    number: '212',
    nationality: 'Dominican',
    flag: '🇩🇲'
  },
  {
    code: 'DO',
    code3: 'DOM',
    name: 'Dominican Republic ',
    number: '214',
    nationality: 'Dominican',
    flag: '🇩🇴'
  },
  {
    code: 'EC',
    code3: 'ECU',
    name: 'Ecuador',
    number: '218',
    nationality: 'Ecuadorian',
    flag: '🇪🇨'
  },
  { code: 'EG', code3: 'EGY', name: 'Egypt', number: '818', nationality: 'Egyptian', flag: '🇪🇬' },
  {
    code: 'SV',
    code3: 'SLV',
    name: 'El Salvador',
    number: '222',
    nationality: 'Salvadoran',
    flag: '🇸🇻'
  },
  {
    code: 'GQ',
    code3: 'GNQ',
    name: 'Equatorial Guinea',
    number: '226',
    nationality: 'Equatoguinean',
    flag: '🇬🇶'
  },
  { code: 'ER', code3: 'ERI', name: 'Eritrea', number: '232', nationality: 'Eritrean', flag: '🇪🇷' },
  { code: 'EE', code3: 'EST', name: 'Estonia', number: '233', nationality: 'Estonian', flag: '🇪🇪' },
  {
    code: 'SZ',
    code3: 'SWZ',
    name: 'Eswatini',
    number: '748',
    nationality: 'Eswatini',
    flag: '🇸🇿'
  },
  {
    code: 'ET',
    code3: 'ETH',
    name: 'Ethiopia',
    number: '231',
    nationality: 'Ethiopian',
    flag: '🇪🇹'
  },
  {
    code: 'FK',
    code3: 'FLK',
    name: 'Falkland Islands  [Malvinas]',
    number: '238',
    nationality: 'Falkland Islander',
    flag: '🇫🇰'
  },
  {
    code: 'FO',
    code3: 'FRO',
    name: 'Faroe Islands ',
    number: '234',
    nationality: 'Faroese',
    flag: '🇫🇴'
  },
  { code: 'FJ', code3: 'FJI', name: 'Fiji', number: '242', nationality: 'Fijian', flag: '🇫🇯' },
  { code: 'FI', code3: 'FIN', name: 'Finland', number: '246', nationality: 'Finnish', flag: '🇫🇮' },
  { code: 'FR', code3: 'FRA', name: 'France', number: '250', nationality: 'French', flag: '🇫🇷' },
  {
    code: 'GF',
    code3: 'GUF',
    name: 'French Guiana',
    number: '254',
    nationality: 'French Guianese',
    flag: '🇬🇵'
  },
  {
    code: 'PF',
    code3: 'PYF',
    name: 'French Polynesia',
    number: '258',
    nationality: 'French Polynesian',
    flag: '🇵🇫'
  },
  {
    code: 'TF',
    code3: 'ATF',
    name: 'French Southern Territories ',
    number: '260',
    nationality: 'French Southern Territories',
    flag: '🇹🇫'
  },
  { code: 'GA', code3: 'GAB', name: 'Gabon', number: '266', nationality: 'Gabonese', flag: '🇬🇦' },
  { code: 'GM', code3: 'GMB', name: 'Gambia ', number: '270', nationality: 'Gambian', flag: '🇬🇲' },
  { code: 'GE', code3: 'GEO', name: 'Georgia', number: '268', nationality: 'Georgian', flag: '🇬🇪' },
  { code: 'DE', code3: 'DEU', name: 'Germany', number: '276', nationality: 'German', flag: '🇩🇪' },
  { code: 'GH', code3: 'GHA', name: 'Ghana', number: '288', nationality: 'Ghanaian', flag: '🇬🇭' },
  {
    code: 'GI',
    code3: 'GIB',
    name: 'Gibraltar',
    number: '292',
    nationality: 'Gibraltar',
    flag: '🇬🇮'
  },
  { code: 'GR', code3: 'GRC', name: 'Greece', number: '300', nationality: 'Greek', flag: '🇬🇷' },
  {
    code: 'GL',
    code3: 'GRL',
    name: 'Greenland',
    number: '304',
    nationality: 'Greenland',
    flag: '🇬🇱'
  },
  {
    code: 'GD',
    code3: 'GRD',
    name: 'Grenada',
    number: '308',
    nationality: 'Grenadian',
    flag: '🇬🇩'
  },
  {
    code: 'GP',
    code3: 'GLP',
    name: 'Guadeloupe',
    number: '312',
    nationality: 'Guadeloupe',
    flag: '🇬🇵'
  },
  { code: 'GU', code3: 'GUM', name: 'Guam', number: '316', nationality: 'Guamanian', flag: '🇬🇺' },
  {
    code: 'GT',
    code3: 'GTM',
    name: 'Guatemala',
    number: '320',
    nationality: 'Guatemalan',
    flag: '🇬🇹'
  },
  {
    code: 'GG',
    code3: 'GGY',
    name: 'Guernsey',
    number: '831',
    nationality: 'Guernsey',
    flag: '🇬🇬'
  },
  { code: 'GN', code3: 'GIN', name: 'Guinea', number: '324', nationality: 'Guinean', flag: '🇬🇳' },
  {
    code: 'GW',
    code3: 'GNB',
    name: 'Guinea-Bissau',
    number: '624',
    nationality: 'Guinean',
    flag: '🇬🇼'
  },
  { code: 'GY', code3: 'GUY', name: 'Guyana', number: '328', nationality: 'Guyanese', flag: '🇬🇾' },
  { code: 'HT', code3: 'HTI', name: 'Haiti', number: '332', nationality: 'Haitian', flag: '🇭🇹' },
  {
    code: 'HM',
    code3: 'HMD',
    name: 'Heard Island and McDonald Islands',
    number: '334',
    nationality: 'Heard Islander',
    flag: '🇭🇲'
  },
  {
    code: 'VA',
    code3: 'VAT',
    name: 'Holy See ',
    number: '336',
    nationality: 'Vatican',
    flag: '🇻🇦'
  },
  {
    code: 'HN',
    code3: 'HND',
    name: 'Honduras',
    number: '340',
    nationality: 'Honduran',
    flag: '🇭🇳'
  },
  {
    code: 'HK',
    code3: 'HKG',
    name: 'Hong Kong',
    number: '344',
    nationality: 'Hong Kong',
    flag: '🇭🇰'
  },
  {
    code: 'HU',
    code3: 'HUN',
    name: 'Hungary',
    number: '348',
    nationality: 'Hungarian',
    flag: '🇭🇺'
  },
  {
    code: 'IS',
    code3: 'ISL',
    name: 'Iceland',
    number: '352',
    nationality: 'Icelander',
    flag: '🇮🇸'
  },
  { code: 'IN', code3: 'IND', name: 'India', number: '356', nationality: 'Indian', flag: '🇮🇳' },
  {
    code: 'ID',
    code3: 'IDN',
    name: 'Indonesia',
    number: '360',
    nationality: 'Indonesian',
    flag: '🇮🇩'
  },
  {
    code: 'IR',
    code3: 'IRN',
    name: 'Iran (Islamic Republic of)',
    number: '364',
    nationality: 'Iranian',
    flag: '🇮🇷'
  },
  { code: 'IQ', code3: 'IRQ', name: 'Iraq', number: '368', nationality: 'Iraqi', flag: '🇮🇶' },
  { code: 'IE', code3: 'IRL', name: 'Ireland', number: '372', nationality: 'Irish', flag: '🇮🇪' },
  { code: 'IM', code3: 'IMN', name: 'Isle of Man', number: '833', nationality: 'Manx', flag: '🇮🇲' },
  { code: 'IL', code3: 'ISR', name: 'Israel', number: '376', nationality: 'Israeli', flag: '🇮🇱' },
  { code: 'IT', code3: 'ITA', name: 'Italy', number: '380', nationality: 'Italian', flag: '🇮🇹' },
  { code: 'JM', code3: 'JAM', name: 'Jamaica', number: '388', nationality: 'Jamaican', flag: '🇯🇲' },
  { code: 'JP', code3: 'JPN', name: 'Japan', number: '392', nationality: 'Japanese', flag: '🇯🇵' },
  { code: 'JE', code3: 'JEY', name: 'Jersey', number: '832', nationality: 'Jersey', flag: '🇯🇪' },
  { code: 'JO', code3: 'JOR', name: 'Jordan', number: '400', nationality: 'Jordanian', flag: '🇯🇴' },
  {
    code: 'KZ',
    code3: 'KAZ',
    name: 'Kazakhstan',
    number: '398',
    nationality: 'Kazakh',
    flag: '🇰🇿'
  },
  { code: 'KE', code3: 'KEN', name: 'Kenya', number: '404', nationality: 'Kenyan', flag: '🇰🇪' },
  {
    code: 'KI',
    code3: 'KIR',
    name: 'Kiribati',
    number: '296',
    nationality: 'I-Kiribati',
    flag: '🇰🇮'
  },
  {
    code: 'KP',
    code3: 'PRK',
    name: 'Korea (the Democratic Peoples Republic of)',
    number: '408',
    nationality: 'North Korean',
    flag: '🇰🇵'
  },
  {
    code: 'KR',
    code3: 'KOR',
    name: 'Korea (the Republic of)',
    number: '410',
    nationality: 'South Korean',
    flag: '🇰🇷'
  },
  { code: 'KW', code3: 'KWT', name: 'Kuwait', number: '414', nationality: 'Kuwaiti', flag: '🇰🇼' },
  {
    code: 'KG',
    code3: 'KGZ',
    name: 'Kyrgyzstan',
    number: '417',
    nationality: 'Kyrgyz',
    flag: '🇰🇾'
  },
  {
    code: 'LA',
    code3: 'LAO',
    name: 'Lao Peoples Democratic Republic ',
    number: '418',
    nationality: 'Lao',
    flag: '🇱🇦'
  },
  { code: 'LV', code3: 'LVA', name: 'Latvia', number: '428', nationality: 'Latvian', flag: '🇱🇻' },
  { code: 'LB', code3: 'LBN', name: 'Lebanon', number: '422', nationality: 'Lebanese', flag: '🇱🇧' },
  { code: 'LS', code3: 'LSO', name: 'Lesotho', number: '426', nationality: 'Basotho', flag: '🇱🇸' },
  { code: 'LR', code3: 'LBR', name: 'Liberia', number: '430', nationality: 'Liberian', flag: '🇱🇷' },
  { code: 'LY', code3: 'LBY', name: 'Libya', number: '434', nationality: 'Libyan', flag: '🇱🇾' },
  {
    code: 'LI',
    code3: 'LIE',
    name: 'Liechtenstein',
    number: '438',
    nationality: 'Liechtensteiner',
    flag: '🇱🇮'
  },
  {
    code: 'LT',
    code3: 'LTU',
    name: 'Lithuania',
    number: '440',
    nationality: 'Lithuanian',
    flag: '🇱🇹'
  },
  {
    code: 'LU',
    code3: 'LUX',
    name: 'Luxembourg',
    number: '442',
    nationality: 'Luxembourger',
    flag: '🇱🇺'
  },
  { code: 'MO', code3: 'MAC', name: 'Macao', number: '446', nationality: 'Macanese', flag: '🇲🇴' },
  {
    code: 'MG',
    code3: 'MDG',
    name: 'Madagascar',
    number: '450',
    nationality: 'Malagasy',
    flag: '🇲🇬'
  },
  { code: 'MW', code3: 'MWI', name: 'Malawi', number: '454', nationality: 'Malawian', flag: '🇲🇼' },
  {
    code: 'MY',
    code3: 'MYS',
    name: 'Malaysia',
    number: '458',
    nationality: 'Malaysian',
    flag: '🇲🇾'
  },
  {
    code: 'MV',
    code3: 'MDV',
    name: 'Maldives',
    number: '462',
    nationality: 'Maldivian',
    flag: '🇲🇻'
  },
  { code: 'ML', code3: 'MLI', name: 'Mali', number: '466', nationality: 'Malian', flag: '🇲🇱' },
  { code: 'MT', code3: 'MLT', name: 'Malta', number: '470', nationality: 'Maltese', flag: '🇲🇹' },
  {
    code: 'MH',
    code3: 'MHL',
    name: 'Marshall Islands ',
    number: '584',
    nationality: 'Marshallese',
    flag: '🇲🇭'
  },
  {
    code: 'MQ',
    code3: 'MTQ',
    name: 'Martinique',
    number: '474',
    nationality: 'Martiniquais',
    flag: '🇲🇶'
  },
  {
    code: 'MR',
    code3: 'MRT',
    name: 'Mauritania',
    number: '478',
    nationality: 'Mauritanian',
    flag: '🇲🇷'
  },
  {
    code: 'MU',
    code3: 'MUS',
    name: 'Mauritius',
    number: '480',
    nationality: 'Mauritian',
    flag: '��🇺'
  },
  { code: 'YT', code3: 'MYT', name: 'Mayotte', number: '175', nationality: 'Mayotte', flag: '🇾🇹' },
  { code: 'MX', code3: 'MEX', name: 'Mexico', number: '484', nationality: 'Mexican', flag: '🇲🇽' },
  {
    code: 'FM',
    code3: 'FSM',
    name: 'Micronesia (Federated States of)',
    number: '583',
    nationality: 'Micronesian',
    flag: '🇫🇲'
  },
  {
    code: 'MD',
    code3: 'MDA',
    name: 'Moldova (the Republic of)',
    number: '498',
    nationality: 'Moldovan',
    flag: '🇲🇩'
  },
  {
    code: 'MC',
    code3: 'MCO',
    name: 'Monaco',
    number: '492',
    nationality: 'Monégasque',
    flag: '🇲🇨'
  },
  {
    code: 'MN',
    code3: 'MNG',
    name: 'Mongolia',
    number: '496',
    nationality: 'Mongolian',
    flag: '🇲🇳'
  },
  {
    code: 'ME',
    code3: 'MNE',
    name: 'Montenegro',
    number: '499',
    nationality: 'Montenegrin',
    flag: '🇲🇪'
  },
  {
    code: 'MS',
    code3: 'MSR',
    name: 'Montserrat',
    number: '500',
    nationality: 'Montserratian',
    flag: '🇲🇸'
  },
  { code: 'MA', code3: 'MAR', name: 'Morocco', number: '504', nationality: 'Moroccan', flag: '🇲🇦' },
  {
    code: 'MZ',
    code3: 'MOZ',
    name: 'Mozambique',
    number: '508',
    nationality: 'Mozambican',
    flag: '🇲🇿'
  },
  { code: 'MM', code3: 'MMR', name: 'Myanmar', number: '104', nationality: 'Burmese', flag: '🇲🇲' },
  { code: 'NA', code3: 'NAM', name: 'Namibia', number: '516', nationality: 'Namibian', flag: '🇳🇦' },
  { code: 'NR', code3: 'NRU', name: 'Nauru', number: '520', nationality: 'Nauruan', flag: '🇳🇷' },
  { code: 'NP', code3: 'NPL', name: 'Nepal', number: '524', nationality: 'Nepali', flag: '🇳🇵' },
  {
    code: 'NL',
    code3: 'NLD',
    name: 'Netherlands ',
    number: '528',
    nationality: 'Dutch',
    flag: '🇳🇱'
  },
  {
    code: 'NC',
    code3: 'NCL',
    name: 'New Caledonia',
    number: '540',
    nationality: 'New Caledonian',
    flag: '🇳🇨'
  },
  {
    code: 'NZ',
    code3: 'NZL',
    name: 'New Zealand',
    number: '554',
    nationality: 'New Zealand',
    flag: '🇳🇿'
  },
  {
    code: 'NI',
    code3: 'NIC',
    name: 'Nicaragua',
    number: '558',
    nationality: 'Nicaraguan',
    flag: '🇳🇮'
  },
  { code: 'NE', code3: 'NER', name: 'Niger ', number: '562', nationality: 'Nigerien', flag: '🇳🇪' },
  { code: 'NG', code3: 'NGA', name: 'Nigeria', number: '566', nationality: 'Nigerian', flag: '🇳🇬' },
  { code: 'NU', code3: 'NIU', name: 'Niue', number: '570', nationality: 'Niuean', flag: '🇳🇺' },
  {
    code: 'NF',
    code3: 'NFK',
    name: 'Norfolk Island',
    number: '574',
    nationality: 'Norfolk Islander',
    flag: '🇳🇫'
  },
  {
    code: 'MP',
    code3: 'MNP',
    name: 'Northern Mariana Islands ',
    number: '580',
    nationality: 'Northern Marianan',
    flag: '🇲🇵'
  },
  { code: 'NO', code3: 'NOR', name: 'Norway', number: '578', nationality: 'Norwegian', flag: '🇳🇴' },
  { code: 'OM', code3: 'OMN', name: 'Oman', number: '512', nationality: 'Omani', flag: '🇴🇲' },
  {
    code: 'PK',
    code3: 'PAK',
    name: 'Pakistan',
    number: '586',
    nationality: 'Pakistani',
    flag: '🇵🇰'
  },
  { code: 'PW', code3: 'PLW', name: 'Palau', number: '585', nationality: 'Palauan', flag: '🇵🇼' },
  {
    code: 'PS',
    code3: 'PSE',
    name: 'Palestine, State of',
    number: '275',
    nationality: 'Palestinian',
    flag: '🇵🇸'
  },
  {
    code: 'PA',
    code3: 'PAN',
    name: 'Panama',
    number: '591',
    nationality: 'Panamanian',
    flag: '🇵🇳'
  },
  {
    code: 'PG',
    code3: 'PNG',
    name: 'Papua New Guinea',
    number: '598',
    nationality: 'Papua New Guinean',
    flag: '🇵🇬'
  },
  {
    code: 'PY',
    code3: 'PRY',
    name: 'Paraguay',
    number: '600',
    nationality: 'Paraguayan',
    flag: '🇵🇾'
  },
  { code: 'PE', code3: 'PER', name: 'Peru', number: '604', nationality: 'Peruvian', flag: '🇵🇪' },
  {
    code: 'PH',
    code3: 'PHL',
    name: 'Philippines ',
    number: '608',
    nationality: 'Filipino',
    flag: '🇵🇭'
  },
  {
    code: 'PN',
    code3: 'PCN',
    name: 'Pitcairn',
    number: '612',
    nationality: 'Pitcairn Islander',
    flag: '🇵🇳'
  },
  { code: 'PL', code3: 'POL', name: 'Poland', number: '616', nationality: 'Polish', flag: '🇵🇱' },
  {
    code: 'PT',
    code3: 'PRT',
    name: 'Portugal',
    number: '620',
    nationality: 'Portuguese',
    flag: '🇵🇹'
  },
  {
    code: 'PR',
    code3: 'PRI',
    name: 'Puerto Rico',
    number: '630',
    nationality: 'Puerto Rican',
    flag: '🇵🇷'
  },
  { code: 'QA', code3: 'QAT', name: 'Qatar', number: '634', nationality: 'Qatari', flag: '🇶🇦' },
  {
    code: 'MK',
    code3: 'MKD',
    name: 'Republic of North Macedonia',
    number: '807',
    nationality: 'Macedonian',
    flag: '🇲🇰'
  },
  { code: 'RO', code3: 'ROU', name: 'Romania', number: '642', nationality: 'Romanian', flag: '🇷🇴' },
  {
    code: 'RU',
    code3: 'RUS',
    name: 'Russian Federation ',
    number: '643',
    nationality: 'Russian',
    flag: '🇷🇺'
  },
  { code: 'RW', code3: 'RWA', name: 'Rwanda', number: '646', nationality: 'Rwandan', flag: '🇷🇼' },
  {
    code: 'RE',
    code3: 'REU',
    name: 'Réunion',
    number: '638',
    nationality: 'Réunionese',
    flag: '🇷🇪'
  },
  {
    code: 'BL',
    code3: 'BLM',
    name: 'Saint Barthélemy',
    number: '652',
    nationality: 'Saint Barthélemy',
    flag: '🇧🇱'
  },
  {
    code: 'SH',
    code3: 'SHN',
    name: 'Saint Helena, Ascension and Tristan da Cunha',
    number: '654',
    nationality: 'Saint Helenian',
    flag: '🇸🇭'
  },
  {
    code: 'KN',
    code3: 'KNA',
    name: 'Saint Kitts and Nevis',
    number: '659',
    nationality: 'Kittitian',
    flag: '🇰🇳'
  },
  {
    code: 'LC',
    code3: 'LCA',
    name: 'Saint Lucia',
    number: '662',
    nationality: 'Saint Lucian',
    flag: '🇱🇨'
  },
  {
    code: 'MF',
    code3: 'MAF',
    name: 'Saint Martin (French part)',
    number: '663',
    nationality: 'Saint Martino',
    flag: '🇲🇫'
  },
  {
    code: 'PM',
    code3: 'SPM',
    name: 'Saint Pierre and Miquelon',
    number: '666',
    nationality: 'Saint-Pierrais',
    flag: '🇵🇲'
  },
  {
    code: 'VC',
    code3: 'VCT',
    name: 'Saint Vincent and the Grenadines',
    number: '670',
    nationality: 'Saint Vincentian',
    flag: '🇻🇨'
  },
  { code: 'WS', code3: 'WSM', name: 'Samoa', number: '882', nationality: 'Samoan', flag: '🇼🇸' },
  {
    code: 'SM',
    code3: 'SMR',
    name: 'San Marino',
    number: '674',
    nationality: 'Sammarinese',
    flag: '🇸🇲'
  },
  {
    code: 'ST',
    code3: 'STP',
    name: 'Sao Tome and Principe',
    number: '678',
    nationality: 'São Toméan',
    flag: '🇸🇹'
  },
  {
    code: 'SA',
    code3: 'SAU',
    name: 'Saudi Arabia',
    number: '682',
    nationality: 'Saudi',
    flag: '🇸🇦'
  },
  {
    code: 'SN',
    code3: 'SEN',
    name: 'Senegal',
    number: '686',
    nationality: 'Senegalese',
    flag: '🇸🇳'
  },
  { code: 'RS', code3: 'SRB', name: 'Serbia', number: '688', nationality: 'Serbian', flag: '🇷🇸' },
  {
    code: 'SC',
    code3: 'SYC',
    name: 'Seychelles',
    number: '690',
    nationality: 'Seychellois',
    flag: '🇸🇨'
  },
  {
    code: 'SL',
    code3: 'SLE',
    name: 'Sierra Leone',
    number: '694',
    nationality: 'Sierra Leonean',
    flag: '🇸🇱'
  },
  {
    code: 'SG',
    code3: 'SGP',
    name: 'Singapore',
    number: '702',
    nationality: 'Singaporean',
    flag: '🇸🇬'
  },
  {
    code: 'SX',
    code3: 'SXM',
    name: 'Sint Maarten (Dutch part)',
    number: '534',
    nationality: 'Sint Maarten',
    flag: '🇸🇽'
  },
  { code: 'SK', code3: 'SVK', name: 'Slovakia', number: '703', nationality: 'Slovak', flag: '🇸🇰' },
  {
    code: 'SI',
    code3: 'SVN',
    name: 'Slovenia',
    number: '705',
    nationality: 'Slovenian',
    flag: '🇸🇮'
  },
  {
    code: 'SB',
    code3: 'SLB',
    name: 'Solomon Islands',
    number: '090',
    nationality: 'Solomon Islander',
    flag: '🇸🇧'
  },
  { code: 'SO', code3: 'SOM', name: 'Somalia', number: '706', nationality: 'Somali', flag: '🇸🇴' },
  {
    code: 'ZA',
    code3: 'ZAF',
    name: 'South Africa',
    number: '710',
    nationality: 'South African',
    flag: '🇿🇦'
  },
  {
    code: 'GS',
    code3: 'SGS',
    name: 'South Georgia and the South Sandwich Islands',
    number: '239',
    nationality: 'South Georgia',
    flag: '🇬🇸'
  },
  {
    code: 'SS',
    code3: 'SSD',
    name: 'South Sudan',
    number: '728',
    nationality: 'South Sudanese',
    flag: '🇸🇸'
  },
  { code: 'ES', code3: 'ESP', name: 'Spain', number: '724', nationality: 'Spanish', flag: '🇪🇸' },
  {
    code: 'LK',
    code3: 'LKA',
    name: 'Sri Lanka',
    number: '144',
    nationality: 'Sri Lankan',
    flag: '🇱🇰'
  },
  { code: 'SD', code3: 'SDN', name: 'Sudan ', number: '729', nationality: 'Sudanese', flag: '🇸🇩' },
  {
    code: 'SR',
    code3: 'SUR',
    name: 'Suriname',
    number: '740',
    nationality: 'Surinamer',
    flag: '🇸🇷'
  },
  {
    code: 'SJ',
    code3: 'SJM',
    name: 'Svalbard and Jan Mayen',
    number: '744',
    nationality: 'Svalbard',
    flag: '🇳🇴'
  },
  { code: 'SE', code3: 'SWE', name: 'Sweden', number: '752', nationality: 'Swedish', flag: '🇸🇪' },
  {
    code: 'CH',
    code3: 'CHE',
    name: 'Switzerland',
    number: '756',
    nationality: 'Swiss',
    flag: '🇨🇭'
  },
  {
    code: 'SY',
    code3: 'SYR',
    name: 'Syrian Arab Republic',
    number: '760',
    nationality: 'Syrian',
    flag: '🇸🇾'
  },
  { code: 'TW', code3: 'TWN', name: 'Taiwan', number: '158', nationality: 'Taiwanese', flag: '🇹🇼' },
  { code: 'TJ', code3: 'TJK', name: 'Tajikistan', number: '762', nationality: 'Tajik', flag: '🇹🇯' },
  {
    code: 'TZ',
    code3: 'TZA',
    name: 'Tanzania, United Republic of',
    number: '834',
    nationality: 'Tanzanian',
    flag: '🇹🇿'
  },
  { code: 'TH', code3: 'THA', name: 'Thailand', number: '764', nationality: 'Thai', flag: '🇹🇭' },
  {
    code: 'TL',
    code3: 'TLS',
    name: 'Timor-Leste',
    number: '626',
    nationality: 'Timorese',
    flag: '🇹🇱'
  },
  { code: 'TG', code3: 'TGO', name: 'Togo', number: '768', nationality: 'Togolese', flag: '🇹🇬' },
  {
    code: 'TK',
    code3: 'TKL',
    name: 'Tokelau',
    number: '772',
    nationality: 'Tokelauan',
    flag: '🇹🇰'
  },
  { code: 'TO', code3: 'TON', name: 'Tonga', number: '776', nationality: 'Tongan', flag: '🇹🇴' },
  {
    code: 'TT',
    code3: 'TTO',
    name: 'Trinidad and Tobago',
    number: '780',
    nationality: 'Trinidadian',
    flag: '🇹🇹'
  },
  { code: 'TN', code3: 'TUN', name: 'Tunisia', number: '788', nationality: 'Tunisian', flag: '🇹🇳' },
  { code: 'TR', code3: 'TUR', name: 'Turkey', number: '792', nationality: 'Turkish', flag: '🇹🇷' },
  {
    code: 'TM',
    code3: 'TKM',
    name: 'Turkmenistan',
    number: '795',
    nationality: 'Turkmen',
    flag: '🇹🇲'
  },
  {
    code: 'TC',
    code3: 'TCA',
    name: 'Turks and Caicos Islands',
    number: '796',
    nationality: 'Turks and Caicos Islander',
    flag: '🇹🇨'
  },
  { code: 'TV', code3: 'TUV', name: 'Tuvalu', number: '798', nationality: 'Tuvaluan', flag: '🇹🇻' },
  { code: 'UG', code3: 'UGA', name: 'Uganda', number: '800', nationality: 'Ugandan', flag: '🇺🇬' },
  {
    code: 'UA',
    code3: 'UKR',
    name: 'Ukraine',
    number: '804',
    nationality: 'Ukrainian',
    flag: '🇺🇦'
  },
  {
    code: 'AE',
    code3: 'ARE',
    name: 'United Arab Emirates',
    number: '784',
    nationality: 'Emirati',
    flag: '🇦🇪'
  },
  {
    code: 'GB',
    code3: 'GBR',
    name: 'United Kingdom',
    number: '826',
    nationality: 'British',
    flag: '🇬🇧'
  },
  {
    code: 'UM',
    code3: 'UMI',
    name: 'United States Minor Outlying Islands',
    number: '581',
    nationality: 'American',
    flag: '🇺🇸'
  },
  {
    code: 'UY',
    code3: 'URY',
    name: 'Uruguay',
    number: '858',
    nationality: 'Uruguayan',
    flag: '🇺🇾'
  },
  { code: 'UZ', code3: 'UZB', name: 'Uzbekistan', number: '860', nationality: 'Uzbek', flag: '🇺🇿' },
  {
    code: 'VU',
    code3: 'VUT',
    name: 'Vanuatu',
    number: '548',
    nationality: 'Vanuatuan',
    flag: '🇻🇺'
  },
  {
    code: 'VE',
    code3: 'VEN',
    name: 'Venezuela',
    number: '862',
    nationality: 'Venezuelan',
    flag: '🇻🇪'
  },
  {
    code: 'VN',
    code3: 'VNM',
    name: 'Viet Nam',
    number: '704',
    nationality: 'Vietnamese',
    flag: '🇻🇳'
  },
  {
    code: 'VG',
    code3: 'VGB',
    name: 'Virgin Islands (British)',
    number: '092',
    nationality: 'British Virgin Islander',
    flag: '🇻🇬'
  },
  {
    code: 'VI',
    code3: 'VIR',
    name: 'Virgin Islands (U.S.)',
    number: '850',
    nationality: 'American Virgin Islander',
    flag: '🇻🇮'
  },
  {
    code: 'WF',
    code3: 'WLF',
    name: 'Wallis and Futuna',
    number: '876',
    nationality: 'Wallisian',
    flag: '🇼🇫'
  },
  {
    code: 'EH',
    code3: 'ESH',
    name: 'Western Sahara',
    number: '732',
    nationality: 'Sahrawi',
    flag: '🇪🇭'
  },
  { code: 'YE', code3: 'YEM', name: 'Yemen', number: '887', nationality: 'Yemeni', flag: '🇾🇪' },
  { code: 'ZM', code3: 'ZMB', name: 'Zambia', number: '894', nationality: 'Zambian', flag: '🇿🇲' },
  {
    code: 'ZW',
    code3: 'ZWE',
    name: 'Zimbabwe',
    number: '716',
    nationality: 'Zimbabwean',
    flag: '🇿🇼'
  },
  {
    code: 'AX',
    code3: 'ALA',
    name: 'Åland Islands',
    number: '248',
    nationality: 'Ålandish',
    flag: '🇦🇽'
  }
];
